import { Box, Theme, useMediaQuery, useTheme } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import HeaderPub from "./dashboard/HeaderPub";
import Footer from "./Footer";

export default function MinimalLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  
  // Check if current page is EventDetailPublic
  const isEventDetailPage = location.pathname.includes('/event/');
  const shouldHideHeader = isMobile && isEventDetailPage;

  return (
    <Box
      sx={(theme: Theme) => ({
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        marginRight: "auto",
        marginLeft: "auto",
        width: "70%",
        justifyContent: "space-between",
        [theme.breakpoints.down("sm")]: {
          width: "100%",
          maxWidth: 425,
        },
      })}
    >
      <Box>
        {!shouldHideHeader && <HeaderPub />}
        <Box
          sx={{
            paddingTop: shouldHideHeader ? "0px" : "80px",
            backgroundColor: "white",
            flexGrow: 1,
            position: "relative",
          }}
        >
          <Outlet />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
}
